// extracted by mini-css-extract-plugin
export default {"content":"style_content__5h44y","intro":"style_intro__5gqc2","signUp_form_container":"style_signUp_form_container__kNNKt"};